<template>
  <!-- 待外发录入列表 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button
          type="primary"
          class="glo_btnItems glo_bgcMainColor"
          @click="batchAddOutgoing()"
          v-permission="'admin:pending:outgoing_order:add'"
        >
          批量外发录入
        </el-button>
        <el-button
          type="primary"
          class="glo_btnItems"
          @click="addOutgoing()"
          v-permission="'admin:pending:outgoing_order:add'"
        >
          新建外发
        </el-button>
        <el-dropdown class="topDropDown" @command="topCommandBtns">
          <el-button type="primary">
            更多操作
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="dtdc">导出</el-dropdown-item>
            <!-- <el-dropdown-item command="dc">导出</el-dropdown-item> -->
            <el-dropdown-item command="bgsz">表格设置</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <queryBtns
        :MoreConditions="MoreConditions"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- 查询条件 -->
    <!-- :formData="queryData" -->
    <queryCondition
      ref="queryForm"
      :More="isHaseMore"
      :formConfig="queryCondditionDatas"
    ></queryCondition>
    <!-- 表格 -->
    <mytable
      :tableData="tableData"
      :myTableHeard="myTableHeard"
      :isShowOperate="true"
      :isselection="true"
      :isShowMoreOperate="false"
      :btnsList="btnsList"
      :btnsMoreList="btnsMoreList"
      :Operatewidth="Operatewidth"
      :showFilter="false"
    >
    </mytable>

    <!-- 分页 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></paging>
    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    ></sorttable>

    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      :queryCondditionDatas="queryCondditionDatas"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
    </exportCompoent>
  </div>
</template>
<script>
import tableListNew from "@/pages/tableListNew.js";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import queryBtns from "@/components/queryBtns.vue";
import queryCondition from "@/components/queryCondition.vue";
import exportjs from "@/assets/js/Mixins/exportDT.js"; //导出的公共js
import mytable from "@/components/table/table.vue";
export default {
  mixins: [tableListNew, exportjs],
  inject: ["reload"],
  components: {
    sorttable,
    paging,
    queryBtns,
    queryCondition,
    mytable,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "待外发录入列表", //导出时默认文件名
        apiName: "/v1/common/query/runPageReport", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "POST", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      pageGroupName: "BusinessOrder_OutgoingManage", //  页面标识
      reportFiledsNumber: "admin_outgoing_wait_list_v5", // 动态 条件、表头
      btnsList: [
        {
          name: "外发录入", //按钮名称
          methods: "batchAddOutgoing", //当前页面的方法
          param: 1, //自定义参数标记
          permission: "admin:pending:outgoing_order:add",
        },
      ],
      // 表格右边更多的操作按钮
      btnsMoreList: [],
      Operatewidth: "220px", //操作列的列宽
    };
  },
  mounted() {},
  watch: {},
  methods: {
    // 新增、 修改 、查看
    batchAddOutgoing(row) {
      if (!row && this.selectTableData.length === 0) {
        this.$message.warning("请选择需要录入的记录");
        return;
      }
      let rows = [];
      if (row) {
        rows = [row.waybillSplitId];
      } else {
        rows = this.selectTableData.map((item) => item.waybillSplitId);
      }
      this.$router.push({
        path: "/OutgoingManage/PendingOutboundEntry/SettlementEntry",
        query: {
          k: rows.length > 1 ? rows : null,
          v: rows.length == 1 ? rows[0] : null,
        },
      });
    },
    addOutgoing() {
      this.$router.push({
        path: "/OutgoingManage/PendingOutboundEntry/addOutgoing",
        query:{
          t:1
        }
      });
    },
  },
};
</script>
<style scoped lang="less">
</style>